export default function PaginationFooter({
  page,
  setPage,
  isPreviousData,
  hasMore,
}: {
  page: number;
  setPage: (page: number) => void;
  isPreviousData: boolean;
  hasMore: boolean;
}) {
  const handlePageChange = (newPage: number) => {
    setPage(newPage);
    window.scrollTo(0, 0);
  };

  return (
    <div className="flex justify-center">
      <div className="flex flex-row gap-4">
        <button
          disabled={isPreviousData || page === 1}
          className="ox-button w-36 py-1"
          onClick={() => handlePageChange(page - 1)}
        >
          Previous Page
        </button>
        <button
          disabled={isPreviousData || !hasMore}
          className="ox-button w-36 py-1"
          onClick={() => handlePageChange(page + 1)}
        >
          Next Page
        </button>
      </div>
    </div>
  );
}
